import styled, { css } from 'styled-components';
import tinycolor from 'tinycolor2';

import Button from '../../../Button';
import mixin from '../../../_foundations/Mixin';

export const JobDetailContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto auto 1fr;
  row-gap: 0;
  height: 100%;
  align-content: start;
`;
export const JobDetailHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  row-gap: 0.25rem;
  column-gap: 0.75rem;
  padding: 0.75rem;
`;
export const JobDetailTitle = styled.div`
  ${mixin.text({ size: 400, strong: true })}
`;
export const JobDetailAddress = styled.div`
  ${mixin.text({ size: 100 })}
`;
export const JobDetailActions = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 0.5rem;
  padding: 0.75rem;
  align-content: start;
  ${mixin.border()}
  border-width: 1px 0;
  & .btn i {
    display: none;
  }
`;
export const JobDetailApplyButton = styled(Button)`
  ${(props) =>
    props.primaryColor &&
    css`
      background-color: ${props.primaryColor} !important;
      color: ${tinycolor(props.primaryColor).isLight()
        ? 'var(--neutral-1000)'
        : 'var(--neutral-10)'} !important;
    `}
`;
export const JobDetailDirectionsButton = styled(Button)``;

export const JobDetailClear = styled.i`
  display: inline-grid !important;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 1em;
  height: 1em;
  vertical-align: middle;
  cursor: pointer;
  & > svg {
    fill: currentColor;
    stroke: currentColor;
    shape-rendering: geometricPrecision;
    height: 1em;
  }
  & > svg path {
    shape-rendering: geometricPrecision;
  }
  ${({ size }) =>
    size &&
    css`
      width: ${size}px;
      height: ${size}px;
      & > svg {
        height: ${size}px;
      }
    `}
  ${({ color }) =>
    color &&
    css`
      color: var(--${color});
    `}
`;

export const JobDetailBody = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 0.25rem;
  padding: 0.75rem;
  overflow: auto;
  align-content: start;
`;
export const JobDetailBodyHeader = styled.h3`
  ${mixin.text({ size: 200, strong: true })}
`;
export const JobDetailBodyContent = styled.div`
  ${mixin.text({ size: 100 })}
`;
